<template>
  <section class="contact-section">
    <div class="container py-5">
      <div class="row align-items-center">
        <div class="col-md-6 text-center">
          <img src="../assets/contactus-illustration.png" alt="Contact Us Illustration" class="img-fluid w-75">
          <a href="tel:+1234567890" class="btn contact-btn mt-3">Call Now (123) 456-7890</a>
        </div>
        <div class="col-md-6">
          <div class="p-4 bg-white rounded shadow">
            <h3>Leave Us a Message</h3>
            <p>Discover. Recover. Thrive.</p>
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <input type="text" class="form-control" v-model="form.fullName" placeholder="Full Name" required>
              </div>
              <div class="mb-3">
                <input type="text" class="form-control" v-model="form.phoneNumber" placeholder="Phone Number" required>
              </div>
              <div class="mb-3">
                <input type="email" class="form-control" v-model="form.email" placeholder="Email Address" required>
              </div>
              <div class="mb-3">
                <input type="date" class="form-control" v-model="form.dob" placeholder="Date of Birth" required>
              </div>
              <div class="mb-3">
                <input type="text" class="form-control" v-model="form.insuranceProvider" placeholder="Insurance Provider">
              </div>
              <div class="mb-3">
                <input type="text" class="form-control" v-model="form.policyNumber" placeholder="Policy Number">
              </div>
              <button type="submit" class="btn btn-primary w-100">Submit Now!</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        fullName: '',
        phoneNumber: '',
        email: '',
        dob: '',
        insuranceProvider: '',
        policyNumber: ''
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Form submitted", this.form);
      // Handle form submission logic here (e.g., send data to API)
    }
  }
};
</script>

<style scoped>
.contact-section {
  background-color: #e6f6ff;
  padding: 50px 0;
}
.contact-btn {
  background-color: #1DBCBC;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  display: inline-block;
  margin-top: 10px;
}
.p-4 {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.btn-primary {
  background-color: #1DBCBC;
  border: none;
}
</style>
